module.exports = __webpack_public_path__ + "static/placeholderimg.c3bac9a5.png";